<template>
  <div>

    <b-row>
      <b-col cols="6" lg="3">
        <b-row>
          <b-col>
            <div
                size="sm"
                class="border-top py-1 pl-3 clickable"
                @click="view='VIEW_ALL'"
            >
              All Reports
            </div>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <div
                size="sm"
                class=" border-top border-bottom py-1 pl-3 clickable"
                @click="view=null"
            >
              Reports without folder
            </div>
          </b-col>
        </b-row>
        <b-row class="my-3">
          <b-col>
            <h5 class="d-inline-block mb-0 align-bottom">Folders</h5>
            <b-button
                size="sm"
                variant="outline-primary"
                class="d-inline-block ml-3"
                @click="addFolder(null)"
            >
              Add
            </b-button>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <div class=" py-1 pl-3">
              <tree-node :items="folderGroups" @deleteFolder="deleteFolder" @editFolder="addFolder"
                         @selectedFolder="selectedFolder"></tree-node>
            </div>
          </b-col>
        </b-row>
      </b-col>
      <b-col>
        <b-row class="mb-3">
          <b-col>
            <h5 class="d-inline-block mb-0 align-bottom">
              <span><b-icon-folder/> {{ viewName }}</span>
            </h5>
            <b-button
                size="sm"
                variant="outline-primary"
                class="d-inline-block ml-3"
                @click="addDashboard"
            >
              Add
            </b-button>
          </b-col>
        </b-row>
        <b-row class="mb-3">
          <b-col>
            <b-form-input v-model="reportNameSearch" trim debounce="1000" placeholder="Search by report name"/>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-list-group>
              <b-list-group-item
                  v-for="report in filteredReports"
                  :key="report.tableauMenuConfigId"
                  @click="loadDashboard(report)"
                  class="dashboard-list-item"
              >
                <b-row>
                  <b-col>
                    <span>
                      {{ report.title }}
                    </span>
                    <b-badge v-for="auth in report.tableauMenuAuths" variant="secondary" class="ml-1 float-right"
                             :key="auth.tableauAuthConfigId">{{ auth.tableauAuthConfigId }}
                    </b-badge>
                  </b-col>
                  <b-col cols="3" sm="2" lg="2">
                    <b-badge
                        class="float-right"
                        variant="info"
                        v-if="report.hidden"
                    >Hidden
                    </b-badge>
                  </b-col>
                </b-row>
              </b-list-group-item>
            </b-list-group>
          </b-col>
        </b-row>
      </b-col>
    </b-row>

    <b-modal
        v-model="folderFormModal"
        centered
        hide-header
        hide-footer
        size="md"
        lazy
    >
      <tableau-folder-form v-model="this.folderFormItems" :folders="folders" @submitForm="submitFolder"/>
    </b-modal>


    <b-modal
        v-model="formModal"
        centered
        hide-header
        size="lg"
        button-size="sm"
        ok-title="Submit"
        @ok="submit"
    >
      <b-form ref="main-form">
        <b-row class="mb-3">
          <b-col cols="4">
            <div>Folder</div>
          </b-col>
          <b-col>
            <b-form-select
                v-model="formItems.tableauMenuFolderId"
                size="sm"
                :options="folderOptions"
            ></b-form-select>
          </b-col>
        </b-row>
        <b-row class="mb-3">
          <b-col cols="4">
            <div>Menu Title</div>
            <div>
              <small class="text-muted">The name to show in the menu</small>
            </div>
          </b-col>
          <b-col>
            <b-form-input
                v-model="formItems.title"
                placeholder="Monthly Report"
                size="sm"
                autofocus
                trim
                required
            ></b-form-input>
          </b-col>
        </b-row>
        <b-row class="mb-3">
          <b-col cols="4">
            <div>Tableau Report Embed Url</div>
            <div>
              <small class="text-muted">Get this from Tableau website</small>
            </div>
          </b-col>
          <b-col>
            <b-form-input
                v-model="formItems.embedUrl"
                placeholder="https://prod-apnortheast-a.online.tableau.com/t/tableauogglobalnet/views/TransactionsDashboard/Playerpreference"
                size="sm"
                trim
                required
            ></b-form-input>
          </b-col>
        </b-row>
        <b-row class="mb-3">
          <b-col cols="4">Show in which group?</b-col>
          <b-col>
            <treeselect
                v-model="groups"
                :multiple="true"
                :options="sortedTableauIdentities"
                value-consists-of="LEAF_PRIORITY"
            ></treeselect>
          </b-col>
        </b-row>
        <b-row class="mb-3">
          <b-col cols="4">Hide Report?</b-col>
          <b-col>
            <b-form-checkbox
                v-model="formItems.hidden"
                :value="true"
                :unchecked-value="false"
            ></b-form-checkbox>
          </b-col>
        </b-row>
      </b-form>
      <!--      <b-row>-->
      <!--        <b-col>-->
      <!--          <b-button class="float-right" v-if="isEdit" variant="danger" size="sm" @click="remove">Remove</b-button>-->
      <!--        </b-col>-->
      <!--      </b-row>-->
    </b-modal>
  </div>
</template>

<script>
import http from '@/mixins/http';
import notification from '@/mixins/notification';
import _ from "lodash";
import TableauFolderServices from "../../services/tableauFolderServices";
import TreeNode from "../../components/admin/tableau/TreeNode.vue";
import TableauFolderForm from "../../components/admin/tableau/TableauFolderForm.vue";

export default {
  name: 'DashboardManagement',
  mixins: [http, notification],
  components: {TableauFolderForm, TreeNode},
  data() {
    const defaultItems = defaultFormItems();
    const defaultFolderItems = defaultFolderFormItems();
    return {
      folders: [],
      reports: [],
      folderFormItems: defaultFolderItems,
      formItems: defaultItems,

      folderFormModal: false,
      formModal: false,
      isEdit: false,

      tableauIdentities: [],
      view: 'VIEW_ALL',
      reportNameSearch: ''
    };
  },
  mounted() {
    this.getFolders();
    this.getList();
    this.getTableauIdentities();
  },
  computed: {
    sortedTableauIdentities() {
      return _.orderBy(this.tableauIdentities, ['label']);
    },
    formattedTableauIdentities() {
      return _.map(this.tableauIdentities, (id) => {
        return {text: id, value: id};
      });
    },
    groups: {
      get() {
        return _.map(this.formItems.tableauMenuAuths, value => {
          return value.tableauAuthConfigId;
        });
      },
      set(v) {
        if (v.length) {
          this.formItems.tableauMenuAuths = _.map(v, value => {
            return {tableauAuthConfigId: value}
          });
        } else {
          this.formItems.tableauMenuAuths = [];
        }
      },
    },
    folderGroups() {
      let arr = _.cloneDeep(this.folders);
      arr = _.orderBy(arr, ['parentId', 'title'])
      if (arr.length)
        return buildTree(arr);

      return [];
    },
    folderOptions() {
      let options = [{value: null, text: 'No Folder'}]

      return [...options, ..._.map(this.folders, folder => {
        const id = folder.tableauMenuFolderId;
        let name = folder.title;
        while (folder.parentId != null) {
          const parent = _.find(this.folders, {tableauMenuFolderId: folder.parentId})
          name = `${parent.title} / ${name}`;
          folder = parent;
        }
        return {value: id, text: name}
      })]
    },
    viewName() {
      const view = this.view;
      if (view === 'VIEW_ALL')
        return 'All Reports'
      else if (view === null)
        return 'Reports without Folder'
      else
        return _.find(this.folders, {tableauMenuFolderId: view})?.title
    },
    filteredReports() {
      const view = this.view;
      return _.chain(this.reports)
          .filter((r) => {
            return this.reportNameSearch === '' || r.title.toLowerCase().includes(this.reportNameSearch.toLowerCase())
          })
          .filter((r) => {
            if (view === 'VIEW_ALL')
              return true;
            else
              return r.tableauMenuFolderId === view
          })
          .orderBy(['tableauMenuFolderId', 'title'])
          .value();
    }
  },
  methods: {
    async getFolders() {
      const resp = await TableauFolderServices.getList()
      this.folders = resp.data
    },
    getList() {
      this.axios.get('/admin/api/tableauConfigs').then(resp => {
        this.reports = resp.data;
      });
    },
    selectedFolder(id) {
      this.reportNameSearch = '';
      this.view = id;
    },
    addFolder(folder = null) {
      this.folderFormItems = _.cloneDeep(folder) || defaultFolderFormItems();
      this.folderFormModal = true;
    },
    async deleteFolder(id) {
      const confirm = await this.$bvModal.msgBoxConfirm('Proceed to delete the Folder?', {centered: true});
      if (confirm) {
        await TableauFolderServices.delete(id);
        await this.getFolders();
        this.PromptSuccess(
            'Success',
            'Folder had been deleted successfully.'
        );
      }
    },
    async submitFolder(data) {
      if (data.tableauMenuFolderId) {
        const confirm = await this.$bvModal.msgBoxConfirm('Proceed to edit the Folder?', {centered: true});
        if (confirm) {
          await TableauFolderServices.edit(data.tableauMenuFolderId, data);
          await this.getFolders();
          this.PromptSuccess(
              'Success',
              'Folder had been updated successfully.'
          );
        }
      } else {
        const confirm = await this.$bvModal.msgBoxConfirm('Proceed to create the Folder?', {centered: true});
        if (confirm) {
          await TableauFolderServices.create(data);
          await this.getFolders();
          this.PromptSuccess(
              'Success',
              'Folder had been created successfully.'
          );
        }
      }

      this.folderFormModal = false
    },
    async getTableauIdentities() {
      let resp = await this.axios.get('api/tableauConfigs/TableauIdentities');
      if (resp?.data) {
        this.tableauIdentities = _.map(resp.data, function (v) {
          return {id: v, label: v};
        });
      }
    },
    loadDashboard(report) {
      this.isEdit = true;
      this.formItems = _.cloneDeep(report);
      this.formModal = true;
    },
    addDashboard() {
      this.isEdit = false;
      this.formItems = defaultFormItems();
      this.formItems.tableauMenuFolderId = this.view === 'VIEW_ALL' ? null : this.view;
      this.formModal = true;
    },
    remove() {
      this.$bvModal
          .msgBoxConfirm('Proceed to remove the Dashboard from menu?', {centered: true})
          .then(value => {
            if (value) {
              const tableauMenuConfigId = this.formItems.tableauMenuConfigId;
              this.formModal = false;
              this.axios.delete(`/admin/api/tableauConfigs/${tableauMenuConfigId}`)
                  .then(() => {
                    this.PromptSuccess(
                        'Success',
                        'Dashboard had been removed successfully.'
                    );
                    this.reports = _.filter(
                        this.reports,
                        report => report.tableauMenuConfigId !== tableauMenuConfigId
                    );
                  });
            }
          });
    },
    submit(e) {
      e.preventDefault();
      const mainForm = this.$refs['main-form'];
      if (!mainForm.reportValidity()) {
        return;
      }
      const formItems = _.cloneDeep(this.formItems);
      if (this.isEdit) {
        this.$bvModal
            .msgBoxConfirm('Proceed to edit the Dashboard?', {centered: true})
            .then(value => {
              if (value) {
                this.formModal = false;
                this.axios
                    .put(
                        '/admin/api/tableauConfigs/' + formItems.tableauMenuConfigId,
                        formItems
                    )
                    .then(() => {
                      this.PromptSuccess(
                          'Success',
                          'Dashboard had been updated successfully.'
                      );
                      let reports = _.filter(
                          this.reports,
                          report => report.tableauMenuConfigId !== formItems.tableauMenuConfigId
                      );
                      reports.push(formItems);
                      this.reports = reports;
                    });
              }
            });
      } else {
        this.$bvModal
            .msgBoxConfirm('Proceed to add the Dashboard?', {centered: true})
            .then(value => {
              if (value) {
                this.formModal = false;
                this.axios.post('/admin/api/tableauConfigs', formItems).then((response) => {
                  this.PromptSuccess(
                      'Success',
                      'Dashboard had been added to the menu successfully.'
                  );
                  this.reports.push(response.data);
                });
              }
            });
      }
    },
  },
};

const defaultFolderFormItems = (parentId = null) => {
  return {
    title: '',
    parentId: parentId,
  };
};

const defaultFormItems = () => {
  return {
    title: '',
    embedUrl: '',
    hidden: false,
    tableauMenuAuths: [],
    tableauMenuFolderId: null
  };
};

const buildTree = (arr, parentId = null) => {
  const result = [];

  arr.forEach(item => {
    if (item.parentId === parentId) {
      const children = buildTree(arr, item.tableauMenuFolderId);
      if (children.length) {
        item.children = children;
      }
      result.push(item);
    }
  });

  return result;
}
</script>

<style scoped>
.dashboard-list-item {
  cursor: pointer;
}

.dashboard-list-item:hover {
  background-color: #ebebeb;
}

.clickable {
  cursor: pointer;
}
</style>